/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-connector': {
    width: 29,
    height: 26,
    viewBox: '0 0 29 26',
    data: '<path pid="0" d="M8.5 13.5a.5.5 0 0 0 0 1v-1zm12.354.854a.5.5 0 0 0 0-.708l-3.182-3.182a.5.5 0 1 0-.707.708L19.793 14l-2.828 2.828a.5.5 0 1 0 .707.707l3.182-3.181zM8.5 14v.5h12v-1h-12v.5z" _fill="url(#svgicon-icon-connector-a)"/><defs><linearGradient id="svgicon-icon-connector-a" x1="14.5" y1="14" x2="14.5" y2="15" gradientUnits="userSpaceOnUse"><stop stop-color="#003D31"/><stop offset="1" stop-color="#006265"/></linearGradient></defs>'
  }
})
